import { useFormContext } from '@calendly/form'
import { useOnValueChange } from '@calendly/hooks'
import { useMemo } from 'react'

import { useETEditorFormikPoolingType } from 'services/event_types'

import { useAddMissingEventTypeMemberships } from '../../availability/utils'

export const useUpdateFormikMembershipsOnCreate = (eventType) => {
  const { setValues } = useFormContext()
  const { isCollectiveRoundRobin } = useETEditorFormikPoolingType()
  const isNewEventType = !eventType?.id
  const addMissingEventTypeMemberships = useAddMissingEventTypeMemberships()

  const eventTypeMembershipsToSync = useMemo(() => eventType.memberships.map(
    ({ location_configuration: locationConfiguration, ...membership }) => ({
      locationConfiguration,
      ...membership,
      ...(isCollectiveRoundRobin ? { user_pool_uid: membership.user_pool_uuid } : {})
    })
  ), [isCollectiveRoundRobin, eventType.memberships])

  useOnValueChange(eventTypeMembershipsToSync, () => {
    if (isNewEventType) {
      setValues((values) => ({
        ...values,
        memberships: eventTypeMembershipsToSync,
        event_type_memberships_attributes: addMissingEventTypeMemberships(eventTypeMembershipsToSync)
      }))
    }
  })
}
